import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { useRecoilState, useRecoilValue } from 'recoil';
import { chatModalState, webviewModalState } from '@/state/session';
import { WebviewContainer } from '../Message/Webview/WebviewContainer';
import { CloseChat } from './ChatModalContent/CloseChat/CloseChat';
import { EmailModal } from './ChatModalContent/EmailModal';
import { Resolved } from './ChatModalContent/Resolved/Resolved';
import { Survey } from './ChatModalContent/Survey/Survey';
export const ChatModal = () => {
    const chatModal = useRecoilValue(chatModalState);
    const [webview, setWebview] = useRecoilState(webviewModalState);
    const showChatForm = chatModal &&
        [
            "closing" /* ChatModalStatus.Closing */,
            "inactivity" /* ChatModalStatus.Inactivity */,
            "expired" /* ChatModalStatus.Expired */,
        ].includes(chatModal);
    const showSurvey = chatModal === "survey" /* ChatModalStatus.Survey */;
    const showResolved = chatModal && chatModal === "closed" /* ChatModalStatus.Resolved */;
    const showEmail = chatModal === "email" /* ChatModalStatus.Email */;
    const handleWebviewClose = () => {
        setWebview(null);
    };
    if (!chatModal && !webview) {
        return null;
    }
    if (webview) {
        return (_jsx("div", { className: cn('absolute bottom-0 z-10 m-0 h-full w-full animate-[slide-in-up_0.2s_ease-out] bg-black/50 shadow-lg will-change-transform'), children: _jsx("div", { className: "absolute bottom-0 h-[78vh] w-full overflow-hidden rounded-[var(--moveo-new-border-radius-base)]", children: _jsx(WebviewContainer, { webview: webview, onClick: handleWebviewClose }) }) }));
    }
    return (_jsxs("div", { className: cn('dark:border-input mx-3 mb-4 animate-[slide-in-up_0.2s_ease-out] rounded-lg border border-gray-200 shadow-lg will-change-transform', {
            'h-[254px]': showChatForm,
            'h-[282px]': chatModal === "closed" /* ChatModalStatus.Resolved */,
            'h-[336px]': chatModal === "survey" /* ChatModalStatus.Survey */,
        }), children: [showChatForm && _jsx(CloseChat, { type: chatModal }), showSurvey && _jsx(Survey, {}), showResolved && _jsx(Resolved, {}), showEmail && _jsx(EmailModal, {})] }));
};
